import React from 'react';
import { Link } from 'react-router-dom';
import Icon from './AppIcon';

const quickLinks = [
  { label: 'Home', to: '/' },
  { label: 'Portfolio', to: '/portfolio' },
  { label: 'About', to: '/about' },
  { label: 'Skills', to: '/skills' },
  { label: 'Websites', to: '/websites' },
  { label: 'Contact', to: '/contact' }
];

const supportLinks = [
  { label: 'FAQ', to: '/faq' },
  { label: 'Contact Support', to: '/contact' }
];

const contactLinks = [
  { label: 'Email', href: 'mailto:info@mustan.dev', external: true },
  { label: 'Contact Form', to: '/contact' }
];

const legalLinks = [
  { label: 'Privacy Policy', to: '/privacy' },
  { label: 'Terms of Service', to: '/terms' }
];

const socialLinks = [
  { name: 'Github', href: 'https://github.com/mustan-dev', icon: 'Github' },
  { name: 'LinkedIn', href: 'https://www.linkedin.com/in/mustan-aliev-774732382/', icon: 'Linkedin' },
  { name: 'Instagram', href: 'https://www.instagram.com/mustan.dev/', icon: 'Instagram' }
];

const Footer = () => {
  return (
    <footer className="bg-gradient-to-b from-slate-900 to-slate-950 border-t border-blue-500/10 text-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-12 space-y-8">
        {/* Main Content Grid */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand Section */}
          <div>
            <Link to="/" className="flex items-center space-x-3 group w-fit mb-4">
              <div className="relative">
                <div className="w-10 h-10 bg-gradient-brand rounded-lg flex items-center justify-center shadow-brand transition-brand group-hover:scale-105">
                  <Icon name="Code2" size={20} color="white" strokeWidth={2.5} />
                </div>
                <div className="absolute -top-1 -right-1 w-3 h-3 bg-accent rounded-full animate-pulse-brand"></div>
              </div>
              <div className="flex flex-col">
                <span className="text-sm font-bold text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-blue-600">
                  Mustan-Dev
                </span>
                <span className="text-xs font-medium text-white/60">Software Engineer & Developer</span>
              </div>
            </Link>
            <p className="text-sm text-white/70 leading-relaxed mb-4">
              Full-Stack Developer crafting modern websites, web applications, and custom programs.
            </p>
            <div className="flex items-center gap-3">
              {socialLinks.map((social) => (
                <a
                  key={social.name}
                  href={social.href}
                  target="_blank"
                  rel="noreferrer"
                  className="p-2 text-white/60 hover:text-blue-400 transition"
                  aria-label={social.name}
                  title={social.name}
                >
                  <Icon name={social.icon} size={18} />
                </a>
              ))}
            </div>
          </div>

          {/* Explore */}
          <div>
            <h3 className="text-xs font-bold uppercase tracking-widest text-white/80 mb-4">Explore</h3>
            <div className="space-y-2">
              {quickLinks.map((link) => (
                <Link key={link.to} to={link.to} className="text-sm text-white/70 hover:text-blue-400 transition block">
                  {link.label}
                </Link>
              ))}
            </div>
          </div>

          {/* Support */}
          <div>
            <h3 className="text-xs font-bold uppercase tracking-widest text-white/80 mb-4">Support</h3>
            <div className="space-y-2">
              {supportLinks.map((link) => (
                <Link key={link.to} to={link.to} className="text-sm text-white/70 hover:text-blue-400 transition block">
                  {link.label}
                </Link>
              ))}
              <a
                href="mailto:info@mustan.dev"
                className="text-sm text-white/70 hover:text-blue-400 transition block"
              >
                Email Support
              </a>
            </div>
          </div>

          {/* Legal */}
          <div>
            <h3 className="text-xs font-bold uppercase tracking-widest text-white/80 mb-4">Legal</h3>
            <div className="space-y-2">
              {legalLinks.map((link) => (
                <Link key={link.to} to={link.to} className="text-sm text-white/70 hover:text-blue-400 transition block">
                  {link.label}
                </Link>
              ))}
            </div>
            <div className="text-xs text-white/50 pt-3 border-t border-white/10 mt-3">
              Hosted on Firebase · Safe connections · GDPR friendly
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-white/5"></div>

        {/* Copyright */}
        <div className="text-center text-xs text-white/50">
          <p>© 2025 - 2026 Mustan-Dev. All rights reserved. Built with passion and cutting-edge technology.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
